import { BaseFilterOptions, BaseFilters, FilterOption, Runnable } from "../../models/types";
import { IColumnVisibility } from "../../molecules/ColumnVisibility";

export const runnablesListFilterOptions: FilterOption<BaseFilters>[] = [
  { label: "Name", value: "name" },
  { label: "Description", value: "description" },
  ...BaseFilterOptions,
];

export const runnablesListColumnsVisibility: IColumnVisibility<Runnable>[] = [
  {
    field: "name",
    headerName: "Name",
    visible: true,
    columnMinWidth: 400,
    renderer: (runnable) => <span>{runnable.name}</span>,
  },
  {
    field: "type",
    headerName: "Type",
    visible: true,
    columnMinWidth: 120,
    columnMaxWidth: 150,
    renderer: (runnable) => <span>{runnable.type ?? ""}</span>,
  },
  {
    field: "last_run",
    headerName: "Last Executed",
    visible: true,
    columnMaxWidth: 120,
    columnMinWidth: 120,
    renderer: (runnable) => runnable.last_run?.updated_on || "N/A",
  },
  {
    field: "status",
    headerName: "Last Status",
    visible: true,
    columnMaxWidth: 150,
    columnMinWidth: 150,
    renderer: (runnable) => <span>{runnable.last_run?.status || "N/A"}</span>,
  },
  {
    field: "deployments",
    headerName: "Deployments",
    visible: true,
    columnMaxWidth: 150,
    columnMinWidth: 150,
  },
];
